module.exports = __webpack_public_path__ + "img/ruler-avatar.f90e0891.svg";